import React, { useEffect, useState } from "react";
import Confetti from "react-confetti";

const Confirmed = ({ colors, values }) => {
  const [showConfetti, setShowConfetti] = useState(true);

  // Désactive les confettis après 5 secondes
  useEffect(() => {
    const timer = setTimeout(() => setShowConfetti(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="space-y-6 p-6 rounded-lg text-center"
      style={{ backgroundColor: colors.background }}
    >
      {showConfetti && (
        <Confetti width={window.innerWidth} height={window.innerHeight} />
      )}

      <h3
        className="text-2xl font-semibold border-b pb-2"
        style={{ borderColor: colors.border }}
      >
        🎉 Félicitations ! 🎉
      </h3>

      <p className="text-lg">Votre adhésion est maintenant prise en compte !</p>

      {values?.name && (
        <p className="mt-4 text-xl font-medium" style={{ color: colors.text }}>
          Bienvenue, {values.pseudo} !
        </p>
      )}

      <div className="mt-8"></div>
    </div>
  );
};

export default Confirmed;
